/**
 * jQuery
 */
import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/tooltip';

require('./bootstrap');
/**
 * Packages
 */
require('magnific-popup');
// require('smooth-scroll');
require('bootstrap-select');
// require('object-fit-images');
// require('swiper');
require('dropzone');
// require('@popperjs/core');
require('leaflet');
// require('nouislider');
// require('prismjs');

// To style all selects
$('select.selectpicker').selectpicker();

/**
 * Theme
 */
// import './datepicker-category';
// import './datepicker-detail';
// import './demo';
import { createDetailMap } from './map-detail';
window.createDetailMap = createDetailMap;
import './theme';

/** Geolocation */
import { getLocation } from './geolocation';
window.getLocation = getLocation;

// Search ajax
$( "#search-form input[name='query']" ).on('input', function( event ) {
    // if ( event.which == 13 ) {
    //     event.preventDefault();
    // }

    if ($(this).val().length < 3) {
        $( "#search-results" ).empty();
        return;
    }

    // Get some values from elements on the page:
    var $form = $( "#search-form" ),
        term = $( this ).val(),
        url = '/search'; //$form.attr( "action" );

    // Send the data using post
    var posting = $.post( {
        url: url,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
    }, { query: term } );

    // Put the results in a div
    posting.done(function( data ) {
        $( "#search-results" ).empty().append( data );
    });
});

$( "#search-form" ).submit(function( event ) {
    // TODO: search results page
});


/**
 * Flash message => Bootrstap.Toast
 *
 * @type {HTMLElement}
 */
let flashMessage = document.getElementById("flash-message");
if (flashMessage) {
    let toast = new bootstrap.Toast(flashMessage);
    toast.show();
}


/**
 * Validation
 */
// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
    'use strict'

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.needs-validation')

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)
        })
})()
